import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { useRouter } from 'next/navigation';

export const useAuthValidation = () => {
  const [isLoading, setIsLoading] = useState(true);
  const router = useRouter();

  useEffect(() => {
    const token = Cookies.get('authToken');

    if (!token) {
      router.push('/login');
      return;
    }

    const validateToken = async () => {
      try {
        const res = await fetch('/api/validate-token');
        if (!res.ok) throw new Error('Invalid');

        const data = await res.json();
        if (data.role !== 'superAdmin' && data.role !== 'admin') {
          router.push('/login');
          return;
        }

        setIsLoading(false);
      } catch (err) {
        Cookies.remove('authToken');
        router.push('/login');
      }
    };

    validateToken();
  }, []);

  return { isLoading };
};


export const useAuthValidateWithoutRedirect = () => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);

  useEffect(() => {
    const token = Cookies.get('authToken');
    if (!token) {
      setIsLoggedIn(false);
      return;
    }

    const validateToken = async () => {
      try {
        const res = await fetch('/api/validate-token');
        if (!res.ok) {
          setIsLoggedIn(false);
          return;
        }

        const data = await res.json();
        if (data.role === 'superAdmin' || data.role === 'admin') {
          setIsLoggedIn(true);
        } else {
          setIsLoggedIn(false);
        }
      } catch (err) {
        Cookies.remove('authToken');
        setIsLoggedIn(false);
      }
    };

    validateToken();
  }, []);

  return { isLoggedIn };
};
